(function () {
  const DURATION = 1600;
  const STAGGER = 120;
  const TEXT_MS = 600;

  function easeOutCubic(t) {
    return 1 - (1 - t) ** 3;
  }

  function formatNum(n) {
    return Math.round(n).toLocaleString('en-US');
  }

  function setMinCh(el, text) {
    const len = String(text).length;
    el.style.minWidth = `${Math.max(len, 2)}ch`;
  }

  function animateNumber(el, label, delay, reduced) {
    const target = Number(el.getAttribute('data-count'));
    const suffix = el.getAttribute('data-suffix') || '';
    const finalText = el.getAttribute('data-display') || el.textContent;
    if (reduced || Number.isNaN(target)) return;

    setMinCh(el, finalText);
    el.textContent = `0${suffix}`;

    setTimeout(() => {
      const start = performance.now();
      const tick = (now) => {
        const t = Math.min(1, (now - start) / DURATION);
        el.textContent = `${formatNum(target * easeOutCubic(t))}${suffix}`;
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = finalText;
      };
      requestAnimationFrame(tick);
      if (label) {
        setTimeout(() => {
          label.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
          label.style.opacity = '1';
          label.style.transform = 'translateY(0)';
        }, 100);
      }
    }, delay);
  }

  function animateText(el, label, delay, reduced) {
    if (reduced) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(12px)';
    setTimeout(() => {
      el.style.transition = `opacity ${TEXT_MS}ms ease, transform ${TEXT_MS}ms ease`;
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
      if (label) {
        setTimeout(() => {
          label.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
          label.style.opacity = '1';
          label.style.transform = 'translateY(0)';
        }, 100);
      }
    }, delay);
  }

  function initStats(root) {
    if (root.dataset.fwStatsInit === 'true') return;
    root.dataset.fwStatsInit = 'true';

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const items = [...root.querySelectorAll('.fw-stats__item')];

    items.forEach((item) => {
      const label = item.querySelector('[data-fw-stats-label]');
      if (label && !reduced) {
        label.style.opacity = '0';
        label.style.transform = 'translateY(8px)';
      }
    });

    const run = () => {
      items.forEach((item, i) => {
        const num = item.querySelector('[data-fw-stats-number]');
        const text = item.querySelector('[data-fw-stats-text]');
        const label = item.querySelector('[data-fw-stats-label]');
        const delay = i * STAGGER;
        if (num) animateNumber(num, label, delay, reduced);
        else if (text) animateText(text, label, delay, reduced);
        else if (label && reduced) {
          label.style.opacity = '1';
          label.style.transform = 'none';
        }
      });
      root.dataset.fwStatsReady = 'true';
    };

    if (reduced) {
      run();
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        run();
      },
      { threshold: 0.4 }
    );
    io.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-fw-stats]').forEach(initStats);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-fw-stats]');
    if (el) initStats(el);
  });
})();
